export default (obj) =>  !Object.keys(obj).length;